/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DemoModeToggleRequest
 */
export interface DemoModeToggleRequest {
    /**
     * 
     * @type {boolean}
     * @memberof DemoModeToggleRequest
     */
    isDemo: boolean;
}

/**
 * Check if a given object implements the DemoModeToggleRequest interface.
 */
export function instanceOfDemoModeToggleRequest(value: object): value is DemoModeToggleRequest {
    if (!('isDemo' in value) || value['isDemo'] === undefined) return false;
    return true;
}

export function DemoModeToggleRequestFromJSON(json: any): DemoModeToggleRequest {
    return DemoModeToggleRequestFromJSONTyped(json, false);
}

export function DemoModeToggleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DemoModeToggleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'isDemo': json['is_demo'],
    };
}

  export function DemoModeToggleRequestToJSON(json: any): DemoModeToggleRequest {
      return DemoModeToggleRequestToJSONTyped(json, false);
  }

  export function DemoModeToggleRequestToJSONTyped(value?: DemoModeToggleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_demo': value['isDemo'],
    };
}

